import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-91a2cc96")

_pushScopeId("data-v-91a2cc96")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "symbol symbol-45px custom" }
const _hoisted_3 = { class: "text-capitalize" }
const _hoisted_4 = { class: "custom" }
const _hoisted_5 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_6 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_8 = { class: "menu-item-wrapper" }
const _hoisted_9 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_11 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode(_component_Search, {
      selectData: _ctx.filterObject,
      filter: true,
      filterPlaceholder: 'message.SELECT',
      onSearch: _ctx.searchHandler,
      inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
      onReloadListing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.users(1, true))),
      onExportFile: _ctx.exportFile
    }, null, 8, ["selectData", "filterPlaceholder", "onSearch", "onExportFile"]),
    _createVNode(_component_Table, {
      columns: _ctx.columns,
      rows: _ctx.result,
      pagination: _ctx.pagination,
      padding: 2,
      onHandleCurrentChange: _ctx.handleCurrentChange,
      loading: _ctx.loader
    }, {
      "cell-avatar": _withId(({row:item}) => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "navatar",
            style: 'background-color:' + _ctx.generateAvatar(item.name).color
          }, [
            _createVNode("span", null, _toDisplayString(_ctx.generateAvatar(item.name).name), 1)
          ], 4)
        ])
      ]),
      "cell-roles": _withId(({row:item}) => [
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.formatRole(item.roles)), 1)
      ]),
      "cell-status": _withId(({row:item}) => [
        _createVNode("div", _hoisted_4, [
          (item.status == 1)
            ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('message.ACTIVE')), 1))
            : (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('message.INACTIVE')), 1))
        ])
      ]),
      "cell-actions": _withId(({row:item}) => [
        _createVNode("button", {
          class: "action-btn",
          type: "button",
          onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
        }, [
          _hoisted_7,
          _createVNode("div", {
            class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
          }, [
            _createVNode("div", _hoisted_8, [
              (_ctx.$can('edit_user'))
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleEdit(item)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_10,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.EDIT')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$can('delete_user') && (_ctx.current_user?.id ? _ctx.current_user?.id != item.id : true) && item?.roles == 'admin')
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleDelete(item.id)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_12,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange", "loading"])
  ]))
})